module.exports = __webpack_public_path__ + "static/media/noStore.593a83fe.svg";